/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useParams } from 'react-router-dom';

import { NodeGroupDetailsPage } from '@/pages/FleetManagement/NodeGroupDetailsPage/NodeGroupDetailsPage';

export function NodeGroupDetailsRoute() {
  const { nodeGroupId } = useParams<{ nodeGroupId: string }>();

  if (!nodeGroupId) {
    return null;
  }

  return <NodeGroupDetailsPage nodeGroupId={nodeGroupId} />;
}
